import { toast } from 'vue3-toastify'

// Success toast
export const showSuccess = (message: string) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
  })
}

// Error toast
export const showError = (message: string) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
  })
}

// Info toast
export const showInfo = (message: string) => {
  toast.info(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
  })
}

// Warning toast
export const showWarning = (message: string) => {
  toast.warning(message, {
    position: 'top-right',
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
  })
}

// Generic toast handler for API responses
export const handleApiResponse = (response: any, successMessage?: string) => {
  if (response.error) {
    showError(response.error || 'An error occurred')
    return false
  } else if (response.message) {
    if (successMessage) {
      showSuccess(successMessage)
    } else {
      showSuccess(response.message)
    }
    return true
  } else {
    if (successMessage) {
      showSuccess(successMessage)
    }
    return true
  }
}

// Handle fetch errors
export const handleFetchError = (error: any, defaultMessage = 'An error occurred') => {
  console.error('Fetch error:', error)
  
  if (error instanceof Error) {
    showError(error.message || defaultMessage)
  } else if (typeof error === 'string') {
    showError(error)
  } else if (error?.message) {
    showError(error.message)
  } else {
    showError(defaultMessage)
  }
}